jQuery(document).ready(function($){

    $('[data-modal-open]').click(function() {
        let $el = $('#' + $(this).data('modal-open'));

        if ($el.length) {
            $el[0].showModal();
        }
    });

    $('dialog').click(function(event) {
        if (event.target !== this) {
            return;
        }

        this.close();
    });

});
